<template>
	<div id="app">
		<v-app id="inspire" style="text-align: center">
			<v-snackbar bottom v-model="getSnackbar.snackbar" :color="getSnackbar.color" :multi-line="getSnackbar.mode" :timeout="getSnackbar.timeout" :vertical="getSnackbar.vertical">
				{{ getSnackbar.text }}
				<template v-slot:action="{ attrs }">
					<v-btn color="white" text v-bind="attrs" @click="close()"> close </v-btn>
				</template>
			</v-snackbar>
		</v-app>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	name: 'Messages',
	data() {
		return {
			text: `Hello !`,
			timeout: 2000000,
		};
	},
	mounted() {},
	computed: {
		...mapGetters({
			getSnackbar: 'settings/getSnackbar',
		}),
	},
	methods: {
		...mapMutations({
			setSnackbar: 'settings/setSnackbar',
		}),
		close() {
			let snack = this.getSnackbar;
			snack.snackbar = false;
			this.setSnackbar(snack);
		},
	},
};
</script>
